import React from 'react';

export const MobileHeroBackdrop: React.FC = () => (
    <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 -z-[1] h-[clamp(28rem,85vw,65rem)] bg-[url('/images/marketing/monery-hero-ribbon-mobile-800.webp')] bg-cover bg-center bg-no-repeat opacity-70 md:bg-[url('/images/marketing/monery-hero-ribbon-mobile-1280.webp')] vl:hidden"
        style={{ maskImage: 'linear-gradient(to bottom, transparent, black 25%, black 70%, transparent)' }}
    />
);
